import Container from "@/components/Container/Container";
import Section from "@/components/Section/Section";
import PageHero from "@/components/PageHero/PageHero";
import CTASection from "@/components/CTASection/CTASection";
import styles from "./AreasOfFocusPage.module.css";

const areas = [
  {
    title: "Trauma & nervous system dysregulation",
    body: "Past experiences can live in both the mind and the body. Trauma-informed therapy focuses on helping the nervous system regain a sense of safety and regulation so that clients can process difficult experiences without becoming overwhelmed.",
  },
  {
    title: "Anxiety & chronic stress",
    body: "Anxiety often reflects a nervous system that has been working overtime for a long time. Therapy can help clients understand the roots of anxiety, build regulation skills, and develop a different relationship to stress.",
  },
  {
    title: "Life transitions",
    body: "Major life changes—whether expected or unexpected—can bring uncertainty, grief, and growth all at once. Therapy provides support in navigating transitions such as career shifts, relationship changes, relocation, parenthood, or identity shifts.",
  },
  {
    title: "Relationship patterns",
    body: "Many people find themselves repeating the same relational patterns in friendships, partnerships, or family dynamics. Therapy can help uncover where these patterns began and create healthier ways of relating.",
  },
  {
    title: "Personal growth & self-understanding",
    body: "Therapy is not only for moments of crisis. Many clients seek therapy as a space to better understand themselves, deepen self-awareness, and create a life that feels more aligned with their values.",
  },
];

export default function AreasOfFocusPage() {
  return (
    <>
      <PageHero
        eyebrow="Areas of focus"
        title="The work that often brings clients to therapy."
        intro="Clients come to therapy for many reasons. These are some of the areas I commonly support, woven through an integrative, trauma-informed approach."
        accent="bloom"
      />

      <Section spacing="loose">
        <Container width="default">
          <div className={styles.list}>
            {areas.map((area, idx) => (
              <article key={area.title} className={styles.item}>
                <span className={styles.index}>0{idx + 1}</span>
                <div className={styles.itemContent}>
                  <h2 className={styles.itemTitle}>{area.title}</h2>
                  <p>{area.body}</p>
                </div>
              </article>
            ))}
          </div>
        </Container>
      </Section>

      <CTASection />
    </>
  );
}
